<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;" >
		<div v-if="createModel">
			<div class="mb-2 mt-2 pt-3">
				<template >
					<el-header style="float: left;">{{ com_info.com_no  }} - {{ com_info.title  }}   <el-tag  style="cursor: pointer;margin-left: 5px;" @click="openDialog(com_info.content)" size="medium">查看</el-tag>
						
						
				</el-header>
				</template>
				<div style="float: right;">
					<el-button type="success" @click="getAllStudents" style="margin-right: 10px;">查看所有學生</el-button>
					<el-button @click="resetForm">返 回</el-button>
				</div>
			</div>
			<div>
				<el-table :data="dialog_list" @sort-change="sortChange" border style="width: 100%">
					<el-table-column
						align="center"
						prop="name"
						label="組別名稱"
						></el-table-column>

						<el-table-column
						align="center"
						prop="start_time"
						label="比賽開始時間"
						></el-table-column>

						<el-table-column
						align="center"
						prop="end_time"
						label="比賽結束時間"
						></el-table-column>

						<el-table-column
						align="center"
						prop="participant_count"
						label="報名人數"
						></el-table-column>

						<el-table-column
						align="center"
						prop="paper_count"
						label="已答卷人數"
						></el-table-column>

						<el-table-column
						align="center"
						prop="time"
						label="時長限制"
						></el-table-column>
						<el-table-column
						align="center"
						prop="latest_time"
						label="最後進入時間"
						></el-table-column>
						<el-table-column prop="id" align="center" width="240" label="操作">
												<template slot-scope="scope">
													<el-button-group>
													<el-button
														size="mini"
														plain
														type="primary"
														@click="getStudent(scope.row.id)"
														>學生詳情</el-button
													>
													<el-button size="mini" v-if="com_info.start_status == 4 && com_info.prize_status == 1" plain type="warning" @click="openPrizeModel(scope.row)">獎品詳情</el-button>
													<el-button
														 v-if="scope.row.apply_status == 1"
															size="mini"
															plain
															type="primary"
															@click="setStudentList(scope.row)">添加學生
														</el-button>
													</el-button-group>
													
												</template>
											</el-table-column>
				</el-table>
			</div>


			
			<el-dialog  :close-on-click-modal="false"  title="添加學生" :visible.sync="createUserModel" 
			
			top="5vh" :width="layout.is_phone?'90%':'60%'" v-loading="payloading" element-loading-text="支付中......">
			<div style="max-height: 65vh; overflow: auto;">
			<div class="mb-2 mt-2 pt-3">
					<!-- 高級搜索 1-->
					<template >
						<el-form inline ref="form" :model="fromUser" label-width="100px">
							<el-form-item label="學生名稱" class="mb-0">
								<el-input size="small" v-model="fromUser.name" placeholder="學生名稱"></el-input>
							</el-form-item>

							<el-form-item label="班別" class="mb-0">
								<el-input size="small" v-model="fromUser.class_id" placeholder="班別"></el-input>
							</el-form-item>
							
							<el-form-item class="mb-0">
								<el-button type="info" @click="searchEventUser" size="small">搜尋 </el-button>
								<el-button size="small" @click="clearSearchUser">清空篩選條件</el-button>
							</el-form-item>
						</el-form>
					</template>
			</div>

				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 顯示當前選擇的數量和總金額 -->
					<div>
						已選擇人數: {{ selectedCount }} 人<span v-if="pay_type == 2">，<span v-if="com_info.discount_code"> 小計: <span class="money_text">{{ totalAmount }}</span> 元，</span>優惠金額: <span class="money_text">{{ totalDiscount }}</span> 元，</span>合計支付金額: <span class="money_text">{{ totalPayAmount }}</span> 元
					</div>
					<!-- 提交按钮 -->
					<!-- <el-button type="primary" @click="submitSelection(1)" :disabled="isSubmitting">報名</el-button> -->
					<el-button type="primary" @click="submitSelectionCart(1)" :disabled="isSubmitting">加入購物車</el-button>
				</div>
				<div v-if="pay_type == 2" style="margin-bottom: 20px; padding: 10px; border: 1px solid #e4e4e4; border-radius: 5px;">
					<!-- <div style="margin-bottom: 10px; font-weight: bold;">選擇支付方式:</div>
					<el-radio-group v-model="selectedPaymentMethod" style="vertical-align: baseline;">
						<el-radio label="paypal">PayPal</el-radio>
					
						<el-radio label="bank_transfer">銀行轉賬</el-radio>
					</el-radio-group> -->
					<el-input placeholder="請輸入優惠碼" v-if="com_info.discount_code" style="width: 300px;margin-left: 30px;" min v-model="input1" @input="handleInput">
						<template slot="prepend">優惠碼</template>
					</el-input>
				</div>
					
				<!-- 表單内容 -->
					<el-table :data="dialog_suer_pay_list" border style="width: 100%" @selection-change="handleSelectionChanges">

						<el-table-column type="selection" width="45" align="center">
						</el-table-column>
							
						<el-table-column align="center" prop="name" label="學生名稱">
						</el-table-column>

						<el-table-column align="center" prop="g_name" label="年級">
					</el-table-column>
					
					<el-table-column align="center" prop="g_name" label="年級">
					</el-table-column>
					
					<el-table-column align="center" prop="g_name" label="年級">
					</el-table-column>

					<el-table-column align="center" prop="class_id" label="班別">
					</el-table-column>

						<el-table-column align="center" prop="number" label="學號">
						</el-table-column>
						
						<el-table-column align="center" prop="money" label="支付金額">
						</el-table-column>

				</el-table>
			
			</div>
			</el-dialog>
			<el-dialog  :close-on-click-modal="false"  title="銀行轉賬信息" :visible.sync="showBankInfo" :before-close="handleDialogClose" width="50%">
				<div >
					<div style="font-size: 16px;font-weight: 700;">
						<div >
							<strong>交易編號：</strong> {{  bankInfo.order_no}}
						</div>
						<div >
							<strong>交易金額：</strong> HKD {{  bankInfo.money}}
						</div>
					</div>
					
					<p style="color: #007cd6;"><span style="margin-right: 5px;font-size: 16px;">※</span>以下為銀行賬號訊息:</p>
					<div style="margin-left: 10px;">
						<div>
							<label style="width: 100px;text-align: right;margin: 0;">銀行名稱</label> ：{{ bankInfo.bankName }}
						</div>
						<div>
							<label style="width: 100px;text-align: right;margin: 0;">收款戶口</label> ：{{ bankInfo.bankUserId }}
						</div>
						<div >
							<label style="width: 100px;text-align: right;margin: 0;">收款人</label> ：{{ bankInfo.bankUserName }}
						</div>
						<div style="color: red;font-weight: 600;">
							<label style="width: 100px;text-align: right;margin: 0;">轉數快</label> ：{{ bankInfo.bankAccount }}
						</div>
					</div>
					<p style="margin: 20px 0 0 0;">-----------------------------------------------------------</p>
					<p style="color: #007cd6;"><span style="margin-right: 5px;font-size: 16px;">※</span> 完成轉賬後，請截圖至<span style="color: red;">{{  bankInfo.ins_name}}</span> 。</p>
					<div style="margin-left: 10px;margin-bottom: 10px;">
						<label style="width: 100px;text-align: right;font-weight: 600;">電郵地址</label> : {{ bankInfo.bankEmail }}
					</div>
					
					<!-- 图片并排 -->
					<div v-if="bankInfo.bankWhatsApp || bankInfo.bankWx" style="margin-left: 10px;display: flex; gap: 20px; margin-bottom: 10px;">
						<div v-if="bankInfo.bankWhatsApp" style="text-align: center;width: 50%;">
							
							<img :src="bankInfo.bankWhatsApp" alt="WhatsApp QR Code" style="width: 150px; height: 150px; display: block;margin: 0 auto;" />
							<strong><img width="20px" src="../../assets/phoneicon.png" alt=""> {{bankInfo.whatsapp}}</strong>
						</div>
						<div v-if="bankInfo.bankWx" style="text-align: center;width: 50%;">
							<img :src="bankInfo.bankWx" alt="WeChat QR Code" style="width: 150px; height: 150px; display: block;margin: 0 auto;" />
							<strong><img width="20px" src="../../assets/vx.png" alt=""> {{bankInfo.vx}}</strong>
						</div>
					</div>
					<div style="width: 100%;height: 58px;border: 1px solid #333333;padding: 5px;">
						{{ bankInfo.content }}
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="handlePaymentComplete">返回</el-button>
				</div>
			</el-dialog>

			<!-- 支付狀態弹窗 -->
			<el-dialog
				:close-on-click-modal="false"
				title="支付狀態"
				:visible.sync="pyaOrderDialog"
				top="5vh"
				:width="layout.is_phone ? '90%' : '60%'"
				@close="closeDialog"
				class="dialogClass"
				>
				<div style="text-align: center; margin-top: 20px;">
					<!-- 支付中 -->
					<div v-if="paymentStatus === ''">
					<p style="color: red; font-weight: bold;">支付進行中！</p>
					<p>請於PayPal畫面進行支付手續… …</p>
					<p><img src="../../assets/jingao.png" alt="Logo" style=" height: auto;"><span style="color: red; font-weight: bold;">請勿關閉或刷新此頁面</span>，以免影響交易過程，導致支付失敗或訂單異常。</p>
					<p>剩餘支付時間：
						<span style="color: red; font-weight: bold;">
						{{ formattedCountdown }}
						</span>
					</p>
					<p>訂單處理時間可能需要幾秒鐘至數分鐘，請保持耐心。如支付長時間未完成，請檢查您的網絡狀態或與您的支付平台聯繫。
						</p>
						<p>如有任何問題，請使用郵件功能聯絡我們的客服團隊，我們將竭誠為您服務！</p>
					</div>

					<!-- 支付成功 -->
					<div v-else-if="paymentStatus === 'success'">
					<p style="color: red; font-weight: bold;">支付成功！</p>
						<p>感謝您的支持！您的支付已成功完成，PayPal已收到您的訂單付款。</p>
						<p>訂單詳情：</p>
						<ul>
							<li style="color: red; font-weight: bold;">訂單編號： {{paymentInfo.order_no}}</li>
							<li>支付方式： PayPal 信用卡</li>
							<li style="color: red; font-weight: bold;">支付金額： 港幣 {{paymentInfo.total_money}} 元</li>
						</ul>
						<p>我們將盡快處理您的訂單，並在發貨後透過電子郵件或訊息通知您物流資訊。您可以隨時登入帳戶查詢訂單狀態。</p>
						<p>如有任何疑問，請隨時使用系統郵件聯絡我們的客服團隊！</p>
					</div>

					<!-- 支付失敗 -->
					<div v-else-if="paymentStatus === 'failure'">
					<p style="color: red; font-weight: bold;">支付失敗！</p>
						<p>我們發現您的支付過程未能成功完成，可能是由以下原因導致：</p>
						<ul>
							<li>信用卡或支付方式資訊輸入錯誤</li>
							<li>銀行或支付平台暫時無法處理交易</li>
							<li>付款授權失敗或餘額不足</li>
							<li>網絡連線問題導致支付中斷</li>
						</ul>
						<p><span style="color: red; font-weight: bold;">請您確認支付資訊是否正確，或稍後重新嘗試付款。</span> 如果問題仍然存在，建議您與您的銀行或支付平台PayPal聯繫，了解詳情。</p>
						<p>如需進一步協助，請使用郵件功能聯絡我們的客服團隊，我們將樂意為您解決問題！</p>
					</div>

					<!-- 支付超时 -->
					<div v-else-if="paymentStatus === 'timeout'">
						<p style="color: red; font-weight: bold;">支付超時！</p>
						<p >您的支付請求已超過<span style=" font-weight: bold;">10分鐘限時</span>，因此系統 <span style="color: red; font-weight: bold;">已自動取消您的訂單</span>。</p>
						<p>可能的原因包括：</p>
						<ul>
							<li>您未在限時內完成支付</li>
							<li>支付過程中遇到網絡或系統問題</li>
						</ul>
						<p>如您仍希望重新下單，請重新操作並在支付時留意限時規則，以確保交易順利完成。</p>
						<p>如有任何疑問，請使用郵件功能聯絡我們的客服團隊，我們將樂意為您提供協助！</p>
					</div>
				</div>

				<!-- 底部按钮 -->
				<span slot="footer" class="dialog-footer">
					<!-- 支付成功的確認按钮 -->
					<el-button
					v-if="paymentStatus === 'success'"
					type="default"
					@click="closeDialogPaySuccess"
					>
					確定
					</el-button>


					<!-- 支付中和其他狀態的返回按钮 -->
					<el-button
					v-else
					type="default"
					@click="closeDialogPay"
					>
					返回
					</el-button>
				</span>
				</el-dialog>

				<el-dialog
			:visible.sync="FenModel"
			:width="layout.is_phone?'90%':'90%'"
			:before-close="hideFenModel"
			
			 v-loading="layout.loading"
			>
			
			<div class="mt-3 pt-2" v-if="tablePrizeData.length>0">
				<!-- 左边 -->
				<template>
					<div style="font-size: 20px;text-align: center;margin-bottom: 20px;">{{ prizeTitle }}</div>
				</template>

				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 显示当前選擇的數量和总金额 -->
					<div>
						已選擇獎品數: {{ selectedPrizeCount }} ，小計: <span class="money_text">{{ totalPrizeAmount }}</span> 元，優惠金額: <span class="money_text">{{ totalDiscount }}</span> 元，合計支付金額: <span class="money_text">{{ totalPrizeAmount }}</span> 元
						<!-- 已選擇獎品數: {{ selectedPrizeCount }} 人<span v-if="pay_type == 2">，<span v-if="com_info.discount_code"> 小計: <span class="money_text">{{ totalAmount }}</span> 元，</span>優惠金額: <span class="money_text">{{ totalDiscount }}</span> 元，</span>合計支付金額: <span class="money_text">{{ totalPayAmount }}</span> 元 -->
				
					</div>
					<div>
						<!-- 提交按钮 -->
						<!-- <el-button type="primary" @click="submitSelection(2)" :disabled="isSubmitting">支付</el-button> -->
						<el-button type="primary" @click="submitSelectionCart(2)" :disabled="isSubmitting">加入購物車</el-button>
					</div>
					
				</div>
				<div v-if="pay_type == 2" style="margin-bottom: 20px; padding: 10px; border: 1px solid #e4e4e4; border-radius: 5px;">
					<el-input placeholder="請輸入優惠碼" v-if="com_info.discount_code" style="width: 300px;margin-left: 30px;" min v-model="input1" @input="handleInput">
						<template slot="prepend">優惠碼</template>
					</el-input>
				</div>
					
				<!-- 顶部選擇信息和提交按钮 -->
				<!-- <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					
					<div>
						已選擇人數: {{ selectedCount }} 人<span v-if="pay_type == 2">，<span v-if="com_info.discount_code"> 小計: <span class="money_text">{{ totalAmount }}</span> 元，</span>優惠金額: <span class="money_text">{{ totalDiscount }}</span> 元，</span>合計支付金額: <span class="money_text">{{ totalPayAmount }}</span> 元
					</div>
				
					<el-button type="primary" @click="submitSelectionCart(1)" :disabled="isSubmitting">加入購物車</el-button>
				</div>
				 -->
				<!-- <div style="margin-bottom: 20px; padding: 10px; border: 1px solid #e4e4e4; border-radius: 5px;">
						<div style="margin-bottom: 10px; font-weight: bold;">選擇支付方式:</div>
						<el-radio-group v-model="selectedPaymentMethod">
							<el-radio label="paypal">PayPal</el-radio>
							<el-radio label="bank_transfer">銀行轉賬</el-radio>
							<el-radio label="payMe">PayMe</el-radio>
						</el-radio-group>
					</div> -->

				<el-table :data="tablePrizeData"  :row-class-name="rowClassName" border style="width: 100%" @selection-change="handleSelectionPrizeChanges" ref="prizeTable">
					<el-table-column type="selection" width="45" align="center"></el-table-column>

					<el-table-column align="center" prop="prize_name" label="獎品名稱">
					</el-table-column>
					
					<el-table-column align="center" prop="content" label="獎品簡介">
								<template slot-scope="scope">
									<div v-if="scope.row.content.length > 20">
										{{ scope.row.content.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.content)">点击查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.content }}
									</div>
								</template>
					</el-table-column>
					<el-table-column align="center" prop="money"  label="價格">
						<template slot-scope="scope">
							<span :class="scope.row.money> 0 ? 'money_text' : ''">{{ scope.row.money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="postage"  label="郵費">
						<template slot-scope="scope">
							<span :class="scope.row.postage> 0 ? 'money_text' : ''">{{ scope.row.postage }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="rank_count"  label="獲獎人數">
						<template slot-scope="scope">
							<span :class="scope.row.rank_count> 0 ? 'text-success' : ''">{{ scope.row.rank_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="pay_count"  label="已購買人數">
						<template slot-scope="scope">
							<span :class="scope.row.pay_count> 0 ? 'text-success' : ''">{{ scope.row.pay_count }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="userCount"  label="已選擇人數">
						<template slot-scope="scope">
							<span :class="scope.row.userCount> 0 ? 'text-success' : ''">{{ scope.row.userCount }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="prizeMoney"  label="應付金額">
						<template slot-scope="scope">
							<span :class="scope.row.prizeMoney> 0 ? 'text-success' : ''">{{ scope.row.prizeMoney }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="id" align="center" width="160" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" plain type="warning" @click="openOrderModel(scope.row)">訂購</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<template #footer>
				<el-button @click="hideFenModel">關閉</el-button>
			</template>
		</el-dialog>


			<el-dialog
				:close-on-click-modal="false"
				:title="prizeUserTitle"
				:visible.sync="pyaOrderModel"
				top="5vh"
				:width="layout.is_phone ? '90%' : '80%'"
				v-loading="payloading"
				element-loading-text="支付中......"
				element-loading-parent
				>
				
				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 顯示當前選擇的數量和總金額 -->
					<div>
					已選擇人數: {{ selectedCount }} 人，合計支付金額: <span class="money_text">{{ totalAmount }}</span> 元
					</div>
					<!-- 提交按钮 -->
					<el-button type="primary" @click="submitSelectionPrize(2)" :disabled="isSubmitting">添加</el-button>
				</div>
				
				<!-- 表單内容 -->
				<el-table :data="dialog_suer_pay_list" ref="userTable" border style="width: 100%" @selection-change="handleSelectionChanges">
					<el-table-column type="selection" width="45" align="center"></el-table-column>
					<el-table-column align="center" prop="user_no" label="學生編號"></el-table-column>
					<el-table-column align="center" prop="name" label="學生名稱"></el-table-column>
					<el-table-column align="center" prop="g_name" label="年級"></el-table-column>
					<el-table-column align="center" prop="class_id" label="班別"></el-table-column>
					<el-table-column align="center" prop="number" label="學號"></el-table-column>
					<el-table-column align="center" prop="money" width="50" label="價格"></el-table-column>
					<el-table-column align="center" prop="postage" width="50" label="郵費"></el-table-column>
					<el-table-column align="center" prop="pay_moeny" label="應付金額"></el-table-column>
				</el-table>
			</el-dialog>

			
			<div class="mb-2 mt-2 pt-3">
				<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 名稱" @search="getsearchEvent" :showGj="true">
				
                    <template #left>
<!-- 					
                    <el-button class="mr-2"  @click="setPayAll(false)" type="primary" size="mini" 
                            v-auth="'add'+auth_val">批量支付</el-button>
                 -->
                        </template>
					<!-- 高級搜索 1-->
					<template #from>
						<el-form inline ref="form" :model="fromUserCom" label-width="100px">

							<el-form-item label="學生名稱" class="mb-0">
								<el-input size="small" v-model="fromUserCom.name" placeholder="學生名稱"></el-input>
							</el-form-item>


							<el-form-item label="學生編號" class="mb-0">
								<el-input size="small" v-model="fromUserCom.user_no" placeholder="學生編號"></el-input>
							</el-form-item>

							<el-form-item label="年級" class="mb-0">
								<el-select v-model="fromUserCom.grade_id" size="small" placeholder="請選擇年級">
									<el-option label="全部" value="-1"></el-option>
									<el-option v-for="item in grade_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="狀態" class="mb-0">
								<el-select v-model="fromUserCom.pay_type" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="未付款" value="1"></el-option>
									<el-option label="已付款" value="2"></el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="報名時間" size="small" class="mb-0">
								<el-date-picker v-model="fromUserCom.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
								range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>

							<el-form-item class="mb-0">
								<el-button type="info" @click="getsearchEvent" size="small">搜尋 </el-button>
								<el-button size="small" @click="clearUserComSearch">清空篩選條件</el-button>
							</el-form-item>

						</el-form>
					</template>
				</button-search>
			</div>

			<div class="mt-3 pt-2">
				<el-table :data="dialog_suer_list" border style="width: 100%" >

                    <el-table-column type="selection" width="45" align="center">
                    </el-table-column>
						
					<el-table-column align="center" prop="join_no" label="參賽編號">
					</el-table-column>
						
					<el-table-column align="center" prop="topic_no" label="試卷編號">
					</el-table-column>


					<el-table-column align="center" prop="user_no" label="學生編號">
					</el-table-column>
					<el-table-column align="center" prop="name" label="學生名稱">
					</el-table-column>
					
					<el-table-column align="center" prop="g_name" label="年級">
					</el-table-column>
					
					<el-table-column align="center" prop="class_id" label="班別">
					</el-table-column>

					<el-table-column align="center" prop="number" label="學號">
					</el-table-column>
                   
					<el-table-column align="center" prop="rank_name" label="獲獎">
						<template slot-scope="v">
								<span  v-if="v.row.start_status==4">{{v.row.rank_name}}</span>
								<span  v-if="v.row.pay_status==1"></span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="pay_status" label="狀態">
							<template slot-scope="v">
								<span class="text-warning" v-if="v.row.comUserStatus==0"></span>
								<span class="text-success" v-if="v.row.comUserStatus==1">已報名</span>
								<span class="text-danger" v-if="v.row.comUserStatus==2">已完成比賽</span>
								<span class="text-danger" v-if="v.row.comUserStatus==3">缺席</span>
							</template>
					</el-table-column>

				
                    <!-- <el-table-column prop="id" align="center" width="120" label="操作">
						
												<template slot-scope="scope">
													<el-button-group>
														
                                                        <el-button
                                                            v-if="scope.row.pay_status==1"
                                                            size="mini"
                                                            plain
                                                            type="primary"
                                                            disabled
                                                            >支付</el-button>
                                                        <el-button
                                                            v-else
                                                            size="mini"
                                                            plain
                                                            type="primary"
                                                            @click="setPay(scope.row)"
                                                            >支付</el-button>
													</el-button-group>
												</template>
				    </el-table-column> -->

				</el-table>
				<el-footer
					class="d-flex bg-white align-items-center px-0"
					style="float: right;"
				>
					<!-- 底部 -->

					<div style="flex: 1" class="px-2">
						<el-pagination
							:current-page="pageScore.current"
							:page-sizes="pageScore.sizes"
							:page-size="pageScore.size"
							@size-change="handleScoreSizeChange"
							@current-change="handleScoreCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pageScore.total"
						>
						</el-pagination>
					</div>
				</el-footer>
			</div>

			<div style="height: 60px;"></div>
			<!-- <el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			
				<div style="flex: 1;" class="px-2">
					<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
					</el-pagination>
				</div>
			</el-footer> -->

			<el-dialog  :close-on-click-modal="false"  title="付款" :visible.sync="createPayModel" 
			top="5vh" :width="layout.is_phone?'90%':'60%'" v-loading="payloading" element-loading-text="支付中......">
				<!-- 表單内容 -->
                    <el-form  :rules="rules" ref="dialogContent" :model="payfrom" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
                        <el-form-item label="學生名稱" >
                            <span>{{payfrom.name}}</span>
                        </el-form-item>

                        <el-form-item label="付款金額" >
                            <span>{{payfrom.money}}</span>
                        </el-form-item>

                        <el-form-item label="付款方式">
                        <el-radio-group v-model="payfrom.type">
                            <el-radio label="1">paypal</el-radio>
                        </el-radio-group>
                    </el-form-item>
				</el-form>

				<div slot="footer" class="dialog-footer">
					<el-button @click="createPayModel = false" :disabled="isSubmitting">
						取 消
					</el-button>
					<el-button type="primary" @click="submitPay" :loading="isSubmitting">
						支 付
					</el-button>
				</div>
			</el-dialog>

		
		
		</div>
		
		<div v-else>

			<div class="mb-2 mt-2 pt-3">
				<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
					<!-- 高級搜索 1-->
					<template #from>
						<el-form inline ref="form" :model="from" label-width="100px">
							<el-form-item label="標題" class="mb-0">
								<el-input size="small" v-model="from.title" placeholder="搜索標題"></el-input>
							</el-form-item>

							<el-form-item label="比賽編號" class="mb-0">
								<el-input size="small" v-model="from.com_no" placeholder="比賽編號"></el-input>
							</el-form-item>
							
							<el-form-item label="是否收費" class="mb-0">
								<el-select v-model="from.pay_type" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="免費" value="1"></el-option>
									<el-option label="收費" value="2"></el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="比賽人選" class="mb-0">
								<el-select v-model="from.is_school" size="small" >
									<el-option label="全部" value="-1"></el-option>
									<el-option label="無限制" value="0"></el-option>
									<el-option label="非學校用戶" value="1"></el-option>
									<el-option label="學校用戶" value="2"></el-option>
								</el-select>
							</el-form-item>
							
							<el-form-item label="創建時間" size="small" class="mb-0">
								<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
								range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>

							<el-form-item class="mb-0">
								<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
								<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
							</el-form-item>

						</el-form>
					</template>
				</button-search>
			</div>

			<!-- 表格 -->
			<div class="mt-3 pt-2">
				<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
					
					<el-table-column align="center" width="120" prop="com_no" label="比賽編號">
					</el-table-column>
						
					<el-table-column align="center" prop="title" label="比賽名稱">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
					</el-table-column>

					<el-table-column align="center" width="100" prop="content" label="比賽簡介">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;"  class="name-wrapper"  @click="openDialog(scope.row.content)">
									<el-tag size="medium">查看</el-tag>
								</div>
						</template>
					</el-table-column>

					<el-table-column align="center" width="80" prop="subject_name" label="學科">
					</el-table-column>
					
					<el-table-column align="center" prop="ins_name" label="機構名稱">
					</el-table-column>

					<el-table-column align="center" width="80" prop="join_count_zero" label="報名人數">
					</el-table-column>

					<el-table-column align="center" width="80" prop="join_count" label="完成人數">
					</el-table-column>
					
					<el-table-column align="center" prop="pay_type" width="80"  label="報名費@">
						<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.pay_type==1">免費</span>
								<span v-if="v.row.pay_type==2">{{v.row.money}}</span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="apply_status" width="80"  label="報名進度">
							<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.apply_status==0">未開始</span>
								<span class="text-success" v-if="v.row.apply_status==1">進行中</span>
								<span class="text-danger" v-if="v.row.apply_status==2">已結束</span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="start_status"  width="80" label="比賽進度">
							<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.start_status==0">未開始</span>
								<span class="text-success" v-if="v.row.start_status==1">進行中</span>
								<span class="text-primary" v-if="v.row.start_status==2">待公佈</span>
								<span class="text-primary" v-if="v.row.start_status==3">待公佈</span>
								<span class="text-danger" v-if="v.row.start_status==4">已公佈</span>
							</template>
					</el-table-column>

					<el-table-column align="center" prop="prize_end_status" width="80" label="訂購狀態">
							<template slot-scope="v">
									<span  class="text-warning" v-if="v.row.prize_end_status==0">未開始</span>
									<span class="text-success" v-if="v.row.prize_end_status==1">進行中</span>
									<span class="text-danger" v-if="v.row.prize_end_status==2">已結束</span>
								</template>
						</el-table-column>
					<!-- <el-table-column align="center" prop="audit_status" width="80"  label="公佈狀態">
							<template slot-scope="v">
								<span  class="text-warning" v-if="v.row.audit_status==0">未提交</span>
								<span class="text-success" v-if="v.row.audit_status==1">待審核</span>
								<span class="text-danger" v-if="v.row.audit_status==2">已完成</span>
								<span class="text-danger" v-if="v.row.audit_status==3">已駁回</span>
							</template>
					</el-table-column>
					 -->
					<!-- <el-table-column align="center" prop="apply_create_time" label="報名時間">
					</el-table-column>
					
					<el-table-column align="center" prop="apply_end_time" label="報名截止時間">
					</el-table-column>

					<el-table-column align="center" prop="result_date" label="比賽時間">
					</el-table-column>
					
					<el-table-column align="center" prop="create_time" width="200" label="創建時間">
					</el-table-column> -->

					<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="180" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button @click="reply(scope)" v-auth="'delRule'" size="mini" plain type="success">聯絡機構</el-button>
								<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row.id)">參賽管理</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div style="height: 60px;"></div>
			<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
				<!-- 底部 -->

				<div style="flex: 1;" class="px-2">
					<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
					</el-pagination>
				</div>
			</el-footer>
		</div>

		<el-dialog  :close-on-click-modal="false"  
			title="聯絡機構" 
			:visible.sync="createReplyModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '50%'" 
			class="custom-dialog"
			>

			<el-form :rules="rulesReply" ref="formEdit" :model="Replyform" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
				<template>
					<el-descriptions
						class="margin-top "
						title="機構信息"
						:column="2"
						style="margin-bottom: 30px;"
						border
					>
						<!-- 電話 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-mobile-phone"></i>
							電話
						</template>
						{{ Replyform.phone }}
						</el-descriptions-item>

						<!-- 電郵 -->
						<el-descriptions-item>
							
						<template slot="label">
							<i class="el-icon-message"></i>
							電郵
						</template>
						<div style="width: 200px;">{{ Replyform.email }}</div>
						
						</el-descriptions-item>

						<!-- 名稱 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名稱
						</template>
						{{ Replyform.ins_name }}
						</el-descriptions-item>

						<!-- 地址 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-position"></i>
							地址
						</template>
						{{ Replyform.local }}
						</el-descriptions-item>

						<!-- 簡介 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-tickets"></i>
							簡介
						</template>
						{{ Replyform.info }}
						</el-descriptions-item>
					</el-descriptions>
					</template>

				<!-- 顶部信息展示区 -->
			

				<!-- 回复標題輸入 -->
				<el-form-item label="標題" prop="reply_title">
				<el-input 
					type="text" 
					v-model="Replyform.reply_title"
					maxlength="50"
					show-word-limit
					placeholder="標題"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

				<!-- 回复内容輸入 -->
				<el-form-item label="内容" prop="reply_content">
				<el-input 
					type="textarea" 
					:rows="3" 
					v-model="Replyform.reply_content"
					maxlength="200"
					show-word-limit
					placeholder="内容"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

			</el-form>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="createReplyModel = false">取消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submitRrply">發送</el-button>
			</div>
			</el-dialog>

			<el-dialog  :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="內容">
			<p>{{ fullTitle }}</p>
		</el-dialog>

			<!-- 查看内容的对话框 -->
			<el-dialog  :close-on-click-modal="false"  :visible.sync="dialogVisible" :width="layout.is_phone?'90%':'70%'" title="比賽簡介" @close="closeDialog">
						<!-- 使用 v-html 渲染 HTML 内容 -->
						<div v-html="dialogContent" class="dialog-content"></div>
						
						<span slot="footer" class="dialog-footer" >
							<el-button @click="closeDialog">關閉</el-button>
						</span>
					</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				submitLoading: false,
				pyaOrderDialog: false, // 控制弹框顯示
				countdown: 600, // 倒计时秒數
				timer: null, // 定时器
				paymentStatus: '', // 支付狀態，success 或 failure
				paymentInfo:[],

				dialogTitleVisible: false,
				fullTitle: '',
				
				selectedPaymentMethod: 'paypal', // 默認選擇 PayPal

				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容

				rulesReply: {
					reply_content: [{
							required: true,
							message: "內容不能為空",
							trigger: 'blur',
						},
					],
					reply_title: [{
							required: true,
							message: "標題不能為空",
							trigger: 'blur',
						},
					],
				
					
				},
				
				fromUser:{
					name:'',
					class_id:'',
				},
				Replyform:{},
				createReplyModel: false,

				pyaOrderModel: false,
				tablePrizeDataIndex: '',
				prizeUserTitle: '',
				pageScore: {
					current: 1,
					sizes: [10, 20, 50, 100],
					size: 50,
					total: 0
				},
				
				createModel: false,
				createPayModel: false,
				createUserModel: false,
				editIndex: -1,
				type:1,
				com_id: null,
				//搜索數据
                com_info_id:null,
				rules: {
					
					num: [
						{
						required: true,
						message: "機器人數量不能為空",
						trigger: 'blur',
						},
						{
						validator: (rule, value, callback) => {
							if (value <= 0) {
							callback(new Error("機器人數量不能小於或等於 0"));
							} else if (value > this.robotNum) {
							callback(new Error(`機器人數量不能大於 ${this.robotNum}`));
							} else {
							callback();
							}
						},
						trigger: 'blur'
						}
					],
				},
				robotNum: 0,
                fromUserCom:{
                    name: '',
                    user_no: '',
					grade_id: '-1',
					pay_type:'-1',
					time: [],
                },
				from: {
					title: '',
					com_no: '',
					pay_type:'-1',
					is_school:'-1',
					time: [],
				},
				formRobot:{
					num:0,
				},
				model_title: 'Notice',
				auth_val: 'data/getComInfo',
				preUrl: "data/getComList", //列表地址
				delAllUrl: "data/delUserEmailAll", //批量删除地址
				delUrl: "data/delUserEmail", //删除單条地址
                editStatusUrl: "data/editStatusUserEmail", //修改狀態地址

				tableData: [],
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
                dialog_list:[],
                com_info:[],
				dialog_suer_list:[],
				dialog_suer_pay_list:[],
                payfrom:{},

				isSubmitting: false, // 是否正在提交，控制按钮狀態
				isCheckingPayment: false, // 是否顯示支付进度条
				com_info_user_id: null,
				com_info_user: [],
				selectedUsers: [] ,// 选中的用戶數据

				selectedPrizeUsers: [] ,// 选中的用戶購買數據

				payloading:false,
				pay_type:2,
				
				FenModel:false,
				tablePrizeData:[],
				tablePrizeDataRow:[],

				priceInfo:[],

				showBankInfo: false, // 是否顯示银行信息对话框
				bankInfo: {
					bankName: '',
					bankUserName: '',
					bankUserId: '',
					bankEmail: '',
					bankWhatsApp: '',
					bankWx: '',
					bankAccount: '',
					vx: '',
					whatsapp: '',
					ins_name: '',
					money: 0,
					order_no: '',
				},
				input1:'',
				discount_money:0,
				
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},

		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state

			formattedCountdown() {
				// 格式化倒计时为分钟:秒
				const minutes = Math.floor(this.countdown / 60);
				const seconds = this.countdown % 60;
				return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
			},
			scrollToTop() {
				// 獲取滾動容器並設置滾動條位置
				const content = this.$refs.dialogContent;
				if (content) {
				content.scrollTop = 0; // 將滾動條設置到頂端
				}
			},
			// 计算选中的人數
			selectedPrizeCount() {
				return this.selectedPrizeUsers.length;
			},

			// 计算合计金額
			totalPrizeAmount() {
				let sum = 0;
				if (this.selectedPrizeUsers && this.selectedPrizeUsers.length > 0) {
					this.selectedPrizeUsers.forEach(user => {
						sum += Number(user.prizeMoney || 0);
						sum -= Number(this.discount_money || 0);
					});
				}
				return sum;
			},
		
			// 计算选中的人數
			selectedCount() {
				return this.selectedUsers.length;
			},

			// 计算合计金額
			totalAmount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(user.money || 0);
						sum += Number(user.postage || 0);
					});
				}
				return sum;
			},
			// 计算合计支付金額
			totalPayAmount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(user.money || 0);
						sum += Number(user.postage || 0);
						sum -= Number(this.discount_money || 0);
					});
				}
				// 確保合计支付金額不小于零
				return Math.max(sum, 0);
			},
			// 優惠金額
			totalDiscount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(this.discount_money || 0);
					});
				}
				// 確保優惠金額不会大于合计金額
				return Math.min(sum, this.totalAmount);
			}

		},
		watch: {
			pyaOrderDialog(val) {
				if (val) {
					this.paymentStatus = '';
					this.startCountdown(); // 开始倒计时
					// this.simulateWebSocket(); // 模拟 WebSocket
				} else {
					clearInterval(this.timer);
					this.timer = null;
				}
			},
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		
		created() {
			this.commonList(['subject_list','grade_list']);
		},
		mounted() {
			// 监听来自 layout 的 `payStatus` 事件
			this.layout.$on('payStatus', (data) => {
				this.checkPaymentStatus(data);
			});
			this.layout.$on('payStatusSchool', (data) => {
				this.handleWebSocketNotification(data);
			});
		},
		
		methods: {
			
			handleInput(value) {
				if(value == this.com_info.discount_code){
					this.discount_money = this.com_info.discount_money;
				}else{
					this.discount_money = 0;
				}
			},
			
			handleDialogClose(done) {
				// 调用支付完成處理逻辑
				this.handlePaymentComplete();
			},
			searchEventUser(){
				this.setStudentList(this.com_info_user)
			},
			clearSearchUser(){
				this.fromUser = {
					name:'',
					class_id:'',
				};
				// 清空後重新拉取列表（無篩選條件）
				if (this.com_info_user && this.com_info_user.id) {
					this.setStudentList(this.com_info_user);
				}
			},
			rowClassName({row, rowIndex}) {
		      //把每一行的索引放进row
		       row.index = rowIndex;
		    },
			handleScoreSizeChange(val) {
				this.pageScore.size = val
				this.pageScore.current = 1
				if(this.com_info_id){
					this.getStudent()
				} else if(this.com_id){
					this.getAllStudents()
				}
			},
			handleScoreCurrentChange(val) {
				this.pageScore.current = val
				if(this.com_info_id){
					this.getStudent()
				} else if(this.com_id){
					this.getAllStudents()
				}
			},
			//幫忙訂購買
			openOrderModel(row){
				this.selectedUsers = []
				this.axios.post('/admin/data/getComPrizeUserList', row, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						this.prizeUserTitle = '添加學生：'+row.name+' - '+row.content
						this.dialog_suer_pay_list = list
						this.priceInfo = row
						 // 默认选中 row.userList 中的用戶
						if (row.userList && row.userList.length > 0) {
							row.userList.forEach(user => {
								const userInTable = this.dialog_suer_pay_list.find(item => item.id === user.id); // 假设 user_no 是唯一標识符
								if (userInTable) {
									this.$nextTick(() => {
										this.$refs.userTable.toggleRowSelection(userInTable, true); // 默认选中该行
									});
								}
							});
							
						}
						this.pyaOrderModel = true;
						this.tablePrizeDataIndex = row.index;
						this.tablePrizeDataRow = row;
						
					}).catch(err => {
						console.log(err)
						this.$message.warning("暫無合適的學生");
						return;
				})
			},
			submitSelectionPrize(){
				if (this.selectedUsers.length == 0) {
					this.$message.warning("請先選擇學生");
					return;
				}
				
				this.$set(this.tablePrizeData[this.tablePrizeDataIndex], 'userList', this.selectedUsers);
				this.$set(this.tablePrizeData[this.tablePrizeDataIndex], 'userCount', this.selectedCount);
				this.$set(this.tablePrizeData[this.tablePrizeDataIndex], 'prizeMoney', this.totalAmount);
				this.$refs.prizeTable.toggleRowSelection(this.tablePrizeDataRow, true);
				this.pyaOrderModel = false; // 關閉对话框
			},
			openPrizeModel(row){
				this.com_info_user_id = row.id;
				this.prizeTitle = '獎品獲得情況 - ' + row.name
				this.layout.loading = true;
				this.axios.post('/admin/data/competitionPrizeList', {
					com_id: row.competition_id,
					com_info_id: row.id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
				
					this.tablePrizeData = list
					this.FenModel = true
					this.layout.loading = false;
				}).catch(err=> { 
					// 失敗
					this.layout.loading = false;
				})
			},
			hideFenModel() {
				this.FenModel = false
			},
				 // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			openDialog(content) {
				this.dialogContent = content; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
			},

			submitRrply() {
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.submitLoading = true;
						this.axios.post('/admin/data/addEmail', 
							this.Replyform,
						 {
							token: true,
						}).then(all => {
							if (all.data.code == 1) {
									this.$message({
										message: all.data.msg,
										type: 'success'
									}); // 控制是否顯示成功提示
								
								this.createReplyModel = false;
								this.submitLoading = false;
							}else{
								this.submitLoading = false;
							}
							
						}).catch(err => {
							// 失敗
							this.submitLoading = false;
						})
					}
				})
				
			},
			startCountdown() {
				this.countdown = 600; // 初始化倒计时
				this.timer = setInterval(() => {
					if (this.countdown > 0) {
					this.countdown--;
					} else {
					this.handleTimeout();
					}
				}, 1000);
			},
			handleTimeout() {
				clearInterval(this.timer);
				if (!this.paymentStatus) {
					this.paymentStatus = 'timeout'; // 倒计时结束默認失敗
				}
			},
			handleWebSocketNotification(status) {
			// WebSocket 收到支付狀態通知
			clearInterval(this.timer);
			if (status['msg'] === 'success') {
				this.paymentStatus = 'success';
				this.paymentInfo = status;
			} else if (status['msg'] === 'failure') {
				this.paymentStatus = 'failure';
			}
			},
			// retryPayment() {
			// 	this.paymentStatus = '';
			// 	this.startCountdown();
			// 	// 触发重新支付逻辑
			// },
			closeDialogPaySuccess() {
				this.handlePaymentComplete()
			},
			closeDialogPay() {
				this.isSubmitting = false;
				this.pyaOrderDialog = false;
				clearInterval(this.timer);
			},
			handleSelectionPrizeChanges(selection){
				this.selectedPrizeUsers = selection;
			},
			 // 處理選擇变化
			 handleSelectionChanges(selection) {
				this.selectedUsers = selection;
			},
			resetForm() {
				this.dialog_list = []
				this.com_info = {}
				this.com_info_id = null; // 重置年级组ID
				this.dialog_suer_list = [] // 清空学生列表
				this.pageScore.current = 1 // 重置页码
		
				this.createModel = false;
				this.editIndex = -1; // 重置 editTagIndex
			},

			
			// 提交选中的數据（购物车）
			submitSelectionCart(type) {
				if (type == 2 && this.selectedPrizeUsers.length == 0) {
					this.$message.warning("請先選擇獎品");
					return;
				}
				if (type == 1 && this.selectedUsers.length == 0) {
					this.$message.warning("請先選擇學生");
					return;
				}
				this.isSubmitting = true;
				const post = {
					discount_code: this.input1,
					
					type: type,
					com_id: this.com_info_user_id,
					...(type === 1 
						? { user: this.selectedUsers } 
						: { price: this.selectedPrizeUsers })
				};
				this.axios.post('/admin/data/schoolUserJoinCart', post, {
					token: true,
				}).then(res => {
					const all = res.data;
					if(all.code == 1){
						this.$message.success("操作成功");
						this.isSubmitting = false;
						this.createUserModel = false; // 關閉对话框
						this.handlePaymentComplete(); // 刷新數据
					}else{
						this.isSubmitting = false;
					}
				}).catch(err => {
					// this.pyaOrderDialog = false;
					this.isSubmitting = false;
					this.$message.error("提交失敗，請稍後再試");
				});
			},
			// 提交选中的數据
			submitSelection(type) {
				if (type == 1 && this.selectedUsers.length == 0) {
					this.$message.warning("請先選擇學生");
					return;
				}
				if (type == 2 && this.selectedPrizeUsers.length == 0) {
					this.$message.warning("請先選擇獎品");
					return;
				}
				// if(this.selectedPaymentMethod !== "bank_transfer" && this.pay_type == 2){
				// 	this.$message.warning("暫時只開放銀行卡轉賬");
				// 	return;
				// }

				this.isSubmitting = true;
				const post = {
					discount_code: this.input1,
					
					pay_type: this.selectedPaymentMethod,
					type: type,
					com_id: this.com_info_user_id,
					...(type === 1 
						? { user: this.selectedUsers } 
						: { price: this.selectedPrizeUsers })
				};

				this.axios.post('/admin/data/schoolUserJoin', post, {
					token: true,
				}).then(res => {
					const all = res.data;
					if(all.code == 1){
						const list = all.data.list;
						if (list.status == 2) {
							// PayPal 支付逻辑
							if (!this.layout.webSocket || this.layout.webSocket.readyState !== WebSocket.OPEN) {
								this.layout.initSocket(); // 如果 WebSocket 未连接，则重新初始化连接
							}
							if (list.url) {
								// 在新窗口打开支付页面
								this.pyaOrderDialog = true;
								window.open(list.url, '_blank');
							} else {
								this.$message.warning("操作失敗");
							}
						} else if (this.selectedPaymentMethod === "bank_transfer") {
							if(this.pay_type == 1 || list.status == 3){
								this.handlePaymentComplete()
							}else{
								// 如果是银行轉賬，展示银行信息
								this.bankInfo = {
									bankName: list.data.bank_name,
									bankUserName: list.data.bank_user_name,
									bankUserId: list.data.bank_user_id,
									bankEmail: list.data.bank_email,
									content: list.data.content,
									bankWhatsApp: list.data.bank_whatsapp,
									bankWx: list.data.bank_wx,
									bankAccount: list.data.bank_account,
									vx: list.data.vx,
									whatsapp: list.data.whatsapp,
									ins_name: list.data.ins_name,
									money: list.data.money,
									order_no: list.data.order_no,
								};
								
								this.showBankInfo = true; // 顯示银行信息对话框
							}
						} else {
							this.isSubmitting = false;
							// this.pyaOrderDialog = false;
							this.createUserModel = false; // 關閉对话框
							this.getsearchEvent(); // 刷新數据
						}
					}else{
						this.isSubmitting = false;
					}
					
				}).catch(err => {
					// this.pyaOrderDialog = false;
					this.isSubmitting = false;
					this.$message.error("提交失敗，請稍後再試");
				});
			},
			handlePaymentComplete() {
				this.isSubmitting = false;
				this.payloading = false;
				this.pyaOrderDialog = false;
				this.createUserModel = false; // 關閉添加學生的对话框
				this.pyaOrderModel = false; // 關閉添加學生的对话框
				this.FenModel = false; // 關閉添加學生的对话框
				this.showBankInfo = false; // 關閉银行信息的对话框
				this.getsearchEvent(); // 刷新數据
			},

			setStudentList(row){
				this.com_info_user = row;
				this.com_info_user_id = row.id;
				this.layout.loading = true;
				this.axios.post('/admin/user/getComUserList', {
					com_info_id: row.id,
					name: this.fromUser.name,
					class_id: this.fromUser.class_id,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						if (all.code == 1) {
							let list = all.data.list
							this.dialog_suer_pay_list = list
							this.pay_type = row.pay_type
							this.createUserModel = true;
						}
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
						this.$message.warning("暫無合適的學生");
					})
			},
			reply(e){
				// 初始化表單數據
				this.Replyform = {
					id: e.row.id,
					in_type: 2,
					in_id: e.row.ins_id,
					ins_name: e.row.ins_name,
					info: e.row.info,
					email: e.row.email,
					local: e.row.local,
					phone: e.row.phone,
					reply_content: '',
					reply_title: '',
				};
				this.editIndex = e.row.id;
				this.createReplyModel = true;
			},
			submitPay() {
                // 禁用按钮和顯示进度条
				this.isSubmitting = true;
				this.isCheckingPayment = true; // 標志支付进度条顯示
			
				// 检查 WebSocket 连接
				if (!this.layout.webSocket || this.layout.webSocket.readyState !== WebSocket.OPEN) {
					this.layout.initSocket(); // 如果 WebSocket 未连接，则重新初始化连接
				}

				this.payloading = true
                this.axios.post('/admin/data/setPayOrder', this.payfrom, {
                    token: true,
                }).then(res => {
                    if (res.data && res.data.data && res.data.data.list && res.data.data.list.url) {
                        const payUrl = res.data.data.list.url;
                        // 在新窗口打开支付页面
                        window.open(payUrl, '_blank');
						
                    } else {
                        console.error("支付鏈接未找到");
                    }
                }).catch(err => {
                    console.error("請求失敗:", err);
                }).finally(() => {
                    // 請求完成後按钮恢复點擊
                    this.isSubmitting = false;
                });
            },

			checkPaymentSchoolStatus(status) {
				// 检查支付结果
				if (status == 1) { // 假设後台返回的 status 中有 success 表示支付成功
					this.$message.success("支付成功！");
				} else {
					this.$message.error("支付失敗或超時，請重試");
				}
				this.isSubmitting = false;
				this.payloading = false
				this.createUserModel = false; // 關閉对话框
				this.getsearchEvent()
            },

            checkPaymentStatus(status) {
				// 检查支付结果
				if (status == 1) { // 假设後台返回的 status 中有 success 表示支付成功
					this.$message.success("支付成功！");
				} else {
					this.$message.error("支付失敗或超时，請重試。");
				}
				this.payloading= false;
				this.isCheckingPayment = false; // 隐藏进度条
				this.createPayModel = false; // 關閉对话框
				this.getsearchEvent()
            },

			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
			},
			setPay(payInfo){
				this.payfrom = {
                    money: payInfo.money,
                    name: payInfo.name,
                    id: payInfo.id,
                    type: '1',
                }
				this.createPayModel = true;
			},
           

			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.grade_list = list.grade
					this.subject_list = list.subject

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			},

            getsearchEvent(){
				// 根据是否有com_info_id决定使用哪个参数
				const params = {
					search: this.fromUserCom,
					page: this.pageScore.current,
					limit: this.pageScore.size,
				};
				if(this.com_info_id){
					params.id = this.com_info_id;
				} else if(this.com_id){
					params.competition_id = this.com_id;
				}
                this.axios.post('/admin/data/getUserComList', params, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.pageScore.total = list.total
					this.dialog_suer_list = list.list
					// 打开dialog
				
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
            },
			//獲取所有學生（所有年级组）
			getAllStudents(){
				if(!this.com_id){
					this.$message.warning("請先選擇比賽");
					return;
				}
				this.com_info_id = null; // 清空年级组ID，使用比赛ID
				this.pageScore.current = 1; // 重置页码
				this.layout.loading = true;
				this.axios.post('/admin/data/getUserComList', {
					competition_id: this.com_id,
					page: this.pageScore.current,
					limit: this.pageScore.size,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.pageScore.total = list.total
					this.dialog_suer_list = list.list
					this.layout.loading = false;
					this.clearUserComSearch()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			//獲取學生詳情
			getStudent(com_info_id){
				if(com_info_id){
					this.com_info_id = com_info_id
				}
                
				this.layout.loading = true;
				this.pageScore.current = 1; // 重置页码
				this.axios.post('/admin/data/getUserComList', {
					id: this.com_info_id,
					page: this.pageScore.current,
					limit: this.pageScore.size,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.pageScore.total = list.total
					this.dialog_suer_list = list.list
					// 打开dialog
					this.layout.loading = false;
					this.clearUserComSearch()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
		
			// 打开模态框
			openModel(e) {
                this.com_info_id = null;
				this.com_id = e;
				this.dialog_suer_list = []
				this.getComInfo()
			},

			getComInfo(){
				this.axios.post('/admin/data/getComInfo', {
					id: this.com_id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.dialog_list = list.list
					this.com_info = list.com_info
					this.createModel = true;
					this.input1='',
					this.discount_money=0,
					this.clearUserComSearch()
				}).catch(err => {
					
				})
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
                clearSearch() {
				this.from = {
                    title: '',
					com_no: '',
					pay_type:'-1',
					is_school:'-1',
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},

				// 清空篩選條件
            clearUserComSearch() {
				
				this.fromUserCom = {
                    name: '',
                    user_no: '',
					grade_id: '-1',
					pay_type:'-1',
					time: [],
                }

				
			},
			
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>


<style>
</style>
<style >

.custom-descriptions .el-descriptions-item__content{
	width: 400px;
}

.dialogClass ul {
    display: inline-block;  /* 使 ul 根据内容宽度自动调整 */
    padding-left: 20px;     /* 设置左侧的内边距，防止列表项紧贴边框 */
}

.dialogClass ul li {
    list-style-type: disc;  /* 或者你可以選擇其他的列表符号 */
    margin-bottom: 10px;    /* 设置每个 li 之間的間距 */
	text-align: left;
}
.triangle-icon {
    position: relative;
    display: inline-block;
    font-size: 30px;
    color: yellow;
}

.triangle {
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 30px solid yellow;
    position: absolute;
    top: 0;
    left: 0;
}

.exclamation {
    position: absolute;
    top: 5px;
    left: 4px;
    font-size: 24px;
}
</style>